/**
 * Converts "Unknown User" or "System Message" to "SYSTEM" for display purposes
 * @param {string} creatorName - The creator name from the backend
 * @returns {string} - "SYSTEM" if creatorName is null, undefined, "Unknown User", or "System Message", otherwise returns the original creatorName
 */
export const getDisplayCreatorName = (creatorName) => {
  if (!creatorName || creatorName === 'Unknown User' || creatorName === 'System Message') {
    return 'SYSTEM';
  }
  return creatorName;
};
